var map = {
	"./frame-card-chieftain.png": 411,
	"./frame-card-elder.png": 412,
	"./frame-card-grandchief.png": 413,
	"./frame-card-highchief.png": 414,
	"./frame-card-overseer.png": 415,
	"./frame-card-warchief.png": 416,
	"./frame-card-warlord.png": 417,
	"./frame-card-warmonger.png": 418,
	"./frame-card-warrior.png": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1032;